import { Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Link as RouterLink } from 'react-router';
import { privacy } from '@e2m-customer-portal/core';
import { Text } from './Text';

export function TermsOfService(): ReactElement {
  return (
    <Text>
      <Typography variant="h2">Allgemeine Nutzungs&shy;bedingungen</Typography>
      <section>
        <Typography variant="h3">Gegenstand dieser Nutzungsbedingungen</Typography>
        <ol>
          <li>
            Gemäß den Regelungen des zwischen dem Erzeuger und der e2m abgeschlossenen Stromliefervertrag über die
            Direktvermarktung von elektrischer Energie (Stromliefervertrag) erhält der Erzeuger Zugang zum
            e2m-Kundenportal. Diese Nutzungsbedingungen regeln den Umfang der Nutzungsmöglichkeiten durch diesen somit
            der näheren Ausgestaltung der Regelungen des Stromliefervertrags.
          </li>
          <li>
            Die e2m behält sich vor, diese Nutzungsbedingungen anzupassen, insbesondere wenn dies aufgrund technischer
            Änderungen oder zur Umsetzung regulatorischer Anpassungen an den Stromhandels- und Regelleistungsmärkten
            erforderlich ist. Die e2m wird den Erzeuger über anstehende Änderungen der Nutzungsbedingungen mindestens 14
            Tage vor deren Inkrafttreten informieren.
          </li>
        </ol>
      </section>
      <section>
        <Typography variant="h3">Zugang zum e2m-Kundenportal</Typography>
        <ol>
          <li>Der Erzeuger erhält vor Lieferbeginn einmalig die nötigen Zugangsdaten zum Kundenportal der e2m.</li>
          <li>
            Der Erzeuger ist verpflichtet, diese Zugangsdaten vertraulich zu behandeln und sie ausschließlich im Rahmen
            der vertraglich vereinbarten Zwecke zu nutzen.
          </li>
          <li>
            Der Erzeuger ist dafür verantwortlich, dass die Zugangsdaten nicht in die Hände Dritter gelangen. Tritt
            dieser Fall doch ein, informiert der Erzeuger die e2m unverzüglich per E-Mail über:
            direktvermarktung@energy2market.de.
          </li>
          <li>Der Erzeuger kann sein Zugangspasswort für das Kundenportal selbstständig über das Portal ändern.</li>
        </ol>
      </section>
      <section>
        <Typography variant="h3">Nutzungsumfang und Nutzungsbedingungen des Kundenportals</Typography>
        <ol>
          <li>
            Der Erzeuger kann im Kundenportal Prognosen für die Erzeugungsleistung und/oder Erzeugungsflexibilität
            seiner Technischen Einheiten (TE) einstellen.
          </li>
          <li>
            „Prognose“ umfasst hier:
            <ol type="a">
              <li>das Erstellen und Ändern von Erzeugungsprognosen und Fahrplänen</li>
              <li>
                das Erstellen und Ändern von Flexibilitätsprognosen zur Regelenergieerbringung und Vermarktung an
                kurzfristigen Handelsmärkten
              </li>
              <li>das Melden von Anlagenausfällen bzw. Nichtverfügbarkeiten</li>
            </ol>
          </li>
          <li>
            Der Erzeuger ist verpflichtet, die im Kundenportal bereitgestellten Funktionen ausschließlich zu den
            vertraglich vereinbarten Zwecken zu nutzen.
          </li>
        </ol>
      </section>
      <section>
        <Typography variant="h3">Informationspflichten und Fristen</Typography>
        <section>
          <Typography variant="h4">Vertraglich bindende Prognoseabgabe</Typography>
          <ol>
            <li>
              Wird durch den Erzeuger eine Prognose für die Erzeugungsleistung sowie die Vermarktung als Regelleistung
              oder an den kurzfristigen Stromhandelsmärkten zur Verfügung stehende Erzeugungsflexibilität eingegeben und
              gespeichert, so wird dies Prognose entsprechend den Regelungen des Stromliefervertrags für die Vermarktung
              durch e2m verbindlich hinterlegt.
            </li>
            <li>
              Nach Ablauf der jeweiligen Anpassungsfrist kommt ein Vertrag über die Vermarktung der durch den Erzeuger
              prognostizierten Flexibilitäts- oder Erzeugungsleistung und eine daraus resultierende Lieferverpflichtung
              des Erzeugers entsprechend den Regelungen des Stromliefervertrags zustande.
            </li>
            <li>
              Falsche oder unvollständige Prognosen und/oder die versäumte oder verspätete Korrektur der
              Erzeugungsprognose auf der Onlineplattform können negative Auswirkungen auf das Vermarktungsergebnis haben
              und stellen eine Verletzung der im Stromliefervertrag geregelten Pflichten des Erzeugers dar.
            </li>
          </ol>
        </section>
        <section>
          <Typography variant="h4">Fristen zur Anpassung von Prognosen</Typography>
          <ol>
            <li>
              Der Erzeuger kann im e2m-Kundenportal täglich Anpassungen an der Erzeugung- und Flexibilitätsprognose
              unter Beachtung bestehender Vermarktungsverpflichtungen (z. B. Regelenergie), vornehmen.
            </li>
            <li>
              Dabei ist der Erzeuger insbesondere verpflichtet,
              <ol type="a">
                <li>Änderungen der abgegebenen Prognose,</li>
                <li>die Meldung von ungeplanten Anlagenausfällen sowie</li>
                <li>planmäßige Abweichungen von der abgegebenen Prognose</li>
              </ol>
              fristgerecht über das Kundenportal mitzuteilen.
            </li>
            <li>
              Es gelten dabei folgende Fristen für die Änderung von Prognosen:
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell variant="head">Produkt</TableCell>
                    <TableCell variant="head">Frist zur Änderung von Prognosen</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Erzeugungsprognose</TableCell>
                    <TableCell>Heute bis 8:30 Uhr für den Folgetag.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>MRL (mFRR)</TableCell>
                    <TableCell>
                      Heute bis 8:00 Uhr am Tag der jeweiligen Regelenergieauktion für den Folgetag.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>SRL (aFRR)</TableCell>
                    <TableCell>
                      Heute bis 8:00 Uhr am Tag der jeweiligen Regelenergieauktion für den Folgetag.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PRL (FCR)</TableCell>
                    <TableCell>Heute bis 6:30 Uhr für den Folgetag.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Erzeugungsprognose in Kombination mit Regelenergie</TableCell>
                    <TableCell>
                      Es gilt die Frist der jeweils präqualifizierten Regelenergie:
                      <br />
                      Erzeugung mit Qualifikation für PRL: heute bis 6:30 Uhr für den Folgetag.
                      <br />
                      Erzeugung mit Qualifikation für SRL/MRL, ohne PRL: heute bis 8:00 Uhr für den Folgetag.
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </li>
            <li>
              Nach Ablauf der jeweiligen Anpassungsfrist ist eine rückwirkende Änderung der abgegebenen Prognose nicht
              mehr möglich.
            </li>
            <li>
              Die e2m ist berechtigt, die genannten Fristen für die Übermittlung und Anpassung der Prognosen jederzeit
              anzupassen. Eine Anpassung der Anpassungsfristen wird dem Erzeuger vier Wochen zuvor per E-Mail oder über
              das Kundenportal mitgeteilt.
            </li>
          </ol>
        </section>
        <section>
          <Typography variant="h4">Meldung von Anlagenausfällen und Nichtverfügbarkeiten</Typography>
          <ol>
            <li>
              Die Mitteilungspflicht des Erzeugers umfasst auch die Informationspflicht bei einer Nichtverfügbarkeit der
              durch die e2m vermarkteten TE.
            </li>
            <li>
              Der Erzeuger ist verpflichtet, die e2m unverzüglich über wesentliche, ungeplante Änderungen des
              Erzeugungsverhaltens seiner TE (z. B. bei Ausfällen, Störfällen, Stillstandzeiten etc.) durch eine
              entsprechenden Ausfallmeldung über das Kundenportal an die e2m zu melden, sobald ihm diese bekannt sind.
            </li>
            <li>
              Der Erzeuger ist ebenfalls bei geplanten Abweichungen, Unterbrechungen oder Beeinträchtigungen von der
              abgegebenen Prognose (z. B. bei geplanten Wartungsarbeiten) verpflichtet, eine entsprechende
              Ausfallmeldung vorzunehmen.
            </li>
            <li>
              Ein Anlagenausfall oder Nichtverfügbarkeit einer TE liegt insbesondere vor, wenn
              <ol type="a">
                <li>
                  eine TE nicht oder nicht in vollem Umfang betrieben und deshalb keine oder nur eingeschränkt
                  elektrische Energie in der betroffenen TE erzeugt werden kann,
                </li>
                <li>
                  die in der TE produzierte elektrische Energie nicht oder nur teilweise in das Netz des für die
                  jeweilige TE benannten Netzbetreibers eingespeist werden kann, gleich aus welchem Grund das der Fall
                  ist,
                </li>
                <li>die TE aufgrund von Wartungsarbeiten nicht erzeugungsfähig ist,</li>
                <li>
                  die an der TE eingesetzte Kommunikations-, Mess- oder Steuerungstechnik gestört oder beeinträchtigt
                  ist.
                </li>
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <Typography variant="h3">Datenschutz</Typography>
          <Typography>
            Der Umgang mit personenbezogenen Daten im Rahmen der Nutzung des e2m-Kundenportals richtet sich nach der im
            e2m-Kundenportal veröffentlichen{' '}
            <Link component={RouterLink} to={privacy.getLink()}>
              Datenschutzerklärung
            </Link>
            .
          </Typography>
        </section>
        <Typography>
          Energy2market GmbH
          <br />
          Stand: 15.04.2024
        </Typography>
      </section>
    </Text>
  );
}
